import React, { useContext, useEffect, memo, useState } from "react";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableFooter,
  Typography,
  Box,
  TextField,
} from "@mui/material";

import { withRouter } from "react-router-dom";
import Row from "./Row";

import AuthContext from "../../../../Context/Auth/AuthContext";
import {
  BackupTable,
  Cancel,
  DeleteForever,
  ListRounded,
  PictureAsPdf,
  Refresh,
} from "@mui/icons-material";

import clienteAxios from "../../../../config/axios";
import { saveAs } from "save-as";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";

import RowNuevo from "./RowNuevo";

import ToolBarTable from "../../../components/Tablas/ToolBarTable";
import TablaCabecera from "../../../components/Tablas/TablaCabecera";
import DialogOpciones from "../../../components/Dialogs/DialogOpciones";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import Cargando from "../../../components/Cargando/Cargando";
import { usePermiso } from "../../../../hooks/usePermiso";
import { useTableStyles } from "../../../../styles/styleTable";
import { set } from "date-fns";
const reducer = (previousValue, currentValue) =>
  Number(previousValue) + Number(currentValue);

const Tabla = (props) => {
  //clases
  const classes = useTableStyles();
  const [cargandoPdfDownload, setcargandoPdfDownload] = useState(false);
  // props
  const {
    //PAGINACION Y BUSQUEDA
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    search,
    input,
    orden,
    setinput,
    setorden,
    cargando,
    setcargando,
    fullBuscador,
    //ESTADO
    rows,
    columns,
    pagination,
    getDataState,
    obtenerState,
    addRowsState,
    remplazarRowsState,
    arrayExport,
    setarrayExport,
    socket,
    campoExport,
    estadoRequest,
    tabla,
    //ROW
    open,
    setopen,
    seteditarFactura,
    changeObjetoActivoStateFactura,
    setopenFactura,
    ObjectoActivoFactura,
  } = props;
  // CONTEXT
  const {
    usuario: { rucempresa },
    usuario,
  } = useContext(AuthContext);
  const { mostrarAlerta } = useContext(AlertaContext);
  // ABRE EL DIALOG DE OPCIONES
  const [openDialogOpciones, setopenDialogOpciones] = useState(false);
  // ABRE EL DIALOG DE CONFIRMACION PARA ELIMINAR
  const [openCDEliminar, setopenCDEliminar] = useState(false);
  // DESHABILITA BOTONES DEL DIALOG SI ESTA CARGANDO
  const [cargandoDialogOpciones, setcargandoDialogOpciones] = useState(false);
  // HOOK DE PERMISO
  const { tienePermiso, alertaPermiso } = usePermiso("Surtidores");
  // FUNCION PARA ELIMINAR SELECCION
  const handleEliminar = async () => {
    if (!tienePermiso("eliminar")) {
      return alertaPermiso("eliminar");
    }

    await setcargando(true);

    await setTimeout(async () => {
      socket.current.emit("client:eliminarDataSeleccionado", {
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
        tabla,
        lista: arrayExport,
      });
      setcargandoDialogOpciones(false);
      setopenCDEliminar(false);
      setcargando(false);
    }, 500);
  };
  // FUNCION PARA CAMBIAR PAGINA
  const handleChangePage = async (event, newPage) => {
    if (newPage * rowsPerPage + rowsPerPage > rows.length) {
      setcargando(true);
      const res = await getDataState(
        rowsPerPage,
        newPage,
        search,
        input.id,
        orden,
        JSON.stringify(fullBuscador),
        rucempresa,
        estadoRequest
      );

      const data = res.data.data.results;

      setcargando(false);
      const resultado = data.filter((row) => {
        const existe = rows.some((item, index) => {
          return row[campoExport] === item[campoExport];
        });

        return !existe;
      });

      addRowsState(resultado);
    }

    setPage(newPage);
  };

  // eslint-disable-next-line
  // FUNCION QUE CAMBIA LOS REGISTROS O FILAS POR PAGINA
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    obtenerState(
      event.target.value,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
  };
  // FUNCION QUE ORDENA DESCENDENTE O ASCENDENTEMENTE
  const funcionOrdenar = async (column) => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      column.id,
      !orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    setPage(0);
    setinput(column);
    setorden(!orden);
    setcargando(false);
  };
  // REFRES
  const funcionReload = async () => {
    setcargando(true);
    setRowsPerPage(10);
    setPage(0);
    await obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    setcargando(false);
  };

  // OBTIENE LA DATA AL CARGAR EL COMPONENTE
  useEffect(() => {
    //eslint-disable-next-line

    obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest
    );
    console.log("obtenerState");

    // eslint-disable-next-line
  }, []);

  const [mes, setmes] = useState("");
  //si no hay usuarios //rows no cargar el componente
  if (!rows) {
    return <Cargando titulo="Cargando" />;
  }
  if (!pagination) {
    return <Cargando titulo="Cargando" />;
  }

  return (
    <Paper className={classes.root}>
      <ConfirmacionDialog
        open={openCDEliminar}
        setopen={setopenCDEliminar}
        categoria="warning"
        titulo={`¿Esta seguro de eliminar estos registros?`}
        botones={[
          {
            tooltip: "Se eliminaran los registros",
            texto: "SI",
            funcion: async () => {
              await handleEliminar();
            },
            disabled: false,
            Icon: DeleteForever,
            color: "error",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenCDEliminar(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <DialogOpciones
        open={openDialogOpciones}
        setopen={setopenDialogOpciones}
        botones={[
          // {
          //   tooltip: "Exportar",
          //   funcion: async () => {
          //     try {
          //       setcargandoDialogOpciones(true);
          //       const json = {
          //         search,
          //         lista: arrayExport.map((itemExport) => itemExport),
          //         rucempresa: usuario.rucempresa,
          //         rol: usuario.rol,
          //         search_avanzado: fullBuscador,
          //       };

          //       const res = await clienteAxios.post(
          //         `reportes/abastecimiento`,
          //         {
          //           ...json,
          //         },
          //         { responseType: "blob" }
          //       );
          //       const pdfBlob = new Blob([res.data], {
          //         type: "application/pdf",
          //       });
          //       saveAs(pdfBlob, `${'abastecimiento'}.pdf`);
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     } catch (error) {
          //       mostrarAlerta("Hubo un error", "error");
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     }
          //   },
          //   Icon: PictureAsPdf,
          //   color: "error",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
          // {
          //   tooltip: "PDF",
          //   funcion: async () => {
          //     try {
          //       setcargandoDialogOpciones(true);
          //       const json = {
          //         tipo: "seleccion",
          //         lista: arrayExport,
          //         rucempresa: usuario.rucempresa,
          //         nombre: usuario.nombre,
          //         usuario: usuario.usuario,
          //       };
          //       const res = await clienteAxios.post(
          //         `/reportes/cierre_caja_gasolinera`,
          //         {
          //           ...json,
          //         },
          //         { responseType: "blob" }
          //       );
          //       const pdfBlob = new Blob([res.data], {
          //         type: "application/pdf",
          //       });
          //       saveAs(pdfBlob, `${"Abastecimiento"}.pdf`);
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     } catch (error) {
          //       mostrarAlerta("Hubo un error", "error");
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     }
          //   },
          //   Icon: PictureAsPdf,
          //   color: "error",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
          // {
          //   tooltip: "CIERRES (Selección)",
          //   funcion: async () => {
          //     try {
          //       setcargandoDialogOpciones(true);
          //       const body = {
          //         tipo: "seleccionado",
          //         lista: arrayExport,
          //         rucempresa: usuario.rucempresa,
          //         nombre: usuario.nombre,
          //         usuario: usuario.usuario,
          //       };
          //       console.log(`/reportes/abastecimiento`, { body });
          //       const res = await clienteAxios.post(
          //         `/reportes/cierre_caja_gasolinera`,
          //         body,
          //         { responseType: "blob" }
          //       );
          //       const pdfBlob = new Blob([res.data], {
          //         type: "application/pdf",
          //       });
          //       saveAs(pdfBlob, `${"Abastecimiento"}.pdf`);
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     } catch (error) {
          //       console.log({ error });

          //       mostrarAlerta("Hubo un error", "error");
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     }
          //   },
          //   Icon: PictureAsPdf,
          //   color: "error",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
          // {
          //   tooltip: "PDF (Mensual)",
          //   funcion: async () => {
          //     try {
          //       setcargandoDialogOpciones(true);
          //       const body = {
          //         tipo: "mensual",
          //         rucempresa: usuario.rucempresa,
          //         lista: [],
          //         anio_mes: mes,
          //       };
          //       console.log(`/reportes/abastecimiento`, { body });
          //       const res = await clienteAxios.post(
          //         `/reportes/cierre_caja_gasolinera`,
          //         body,
          //         { responseType: "blob" }
          //       );
          //       const pdfBlob = new Blob([res.data], {
          //         type: "application/pdf",
          //       });
          //       saveAs(pdfBlob, `${"Abastecimiento"}.pdf`);
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     } catch (error) {
          //       mostrarAlerta("Hubo un error", "error");
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     }
          //   },
          //   Icon: PictureAsPdf,
          //   color: "error",
          //   id: 1,
          //   disabled: cargandoDialogOpciones || mes === "",
          // },
          // {
          //   tooltip: "PDF (Todos)",
          //   funcion: async () => {
          //     try {
          //       const validarFullBuscador = (fullBuscador) => {
          //         const NoieneContenido =
          //           fullBuscador.fechaHora1 === "" ||
          //           fullBuscador.usuario === "";

          //         if (NoieneContenido) {
          //           mostrarAlerta(
          //             "Debe ingresar el usuario y al menos una fecha como parámetro de busqueda",
          //             "error"
          //           );
          //           return false;
          //         }

          //         return true;
          //       };

          //       if (!validarFullBuscador(fullBuscador)) {
          //         return;
          //       }
          //       setcargandoDialogOpciones(true);
          //       const body = {
          //         tipo: "todos",
          //         rucempresa: usuario.rucempresa,
          //         lista: [],
          //         search_avanzado: fullBuscador,
          //       };
          //       console.log(`/reportes/abastecimiento`, { body });
          //       const res = await clienteAxios.post(
          //         `/reportes/cierre_caja_gasolinera`,
          //         body,
          //         { responseType: "blob" }
          //       );
          //       const pdfBlob = new Blob([res.data], {
          //         type: "application/pdf",
          //       });
          //       saveAs(pdfBlob, `${"Abastecimiento"}.pdf`);
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     } catch (error) {
          //       console.log({ error });

          //       mostrarAlerta("Hubo un error", "error");
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     }
          //   },
          //   Icon: PictureAsPdf,
          //   color: "error",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
          {
            tooltip: "Excel (Selección)",
            funcion: async () => {
              try {
                setcargandoDialogOpciones(true);
                const json = {
                  tipo: "seleccion",
                  lista: arrayExport,
                  rucempresa: usuario.rucempresa,
                  nombre: usuario.nombre,
                  usuario: usuario.usuario,
                };
                console.log(`/reportes/excel/abastecimiento`, { json });
                const res = await clienteAxios.post(
                  `/reportes/excel/abastecimiento`,
                  {
                    ...json,
                  },
                  { responseType: "blob" }
                );
                const excelBlob = new Blob([res.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(excelBlob, `${"Abastecimiento"}.xlsx`);
                setopen(false);
                setcargandoDialogOpciones(false);
              } catch (error) {
                console.log({ error });
                mostrarAlerta("Hubo un error", "error");
                setopen(false);
                setcargandoDialogOpciones(false);
              }
            },
            Icon: BackupTable,
            color: "success",
            id: 1,
            disabled: cargandoDialogOpciones,
          },
          {
            tooltip: "Excel (Mensual)",
            funcion: async () => {
              try {
                setcargandoDialogOpciones(true);
                const json = {
                  tipo: "mensual",
                  lista: [],
                  rucempresa: usuario.rucempresa,
                  nombre: usuario.nombre,
                  usuario: usuario.usuario,
                  anio_mes: mes,
                };
                console.log(`/reportes/excel/abastecimiento`, { json });
                const res = await clienteAxios.post(
                  `/reportes/excel/abastecimiento`,
                  {
                    ...json,
                  },
                  { responseType: "blob" }
                );
                const excelBlob = new Blob([res.data], {
                  type:
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(excelBlob, `${"Abastecimiento"}.xlsx`);
                setopen(false);
                setcargandoDialogOpciones(false);
              } catch (error) {
                console.log({ error });
                mostrarAlerta("Hubo un error", "error");
                setopen(false);
                setcargandoDialogOpciones(false);
              }
            },
            Icon: BackupTable,
            color: "success",
            id: 1,
            disabled: cargandoDialogOpciones || mes === "",
          },
          // {
          //   tooltip: "Excel (Todos)",
          //   funcion: async () => {
          //     try {
          //       const validarFullBuscador = (fullBuscador) => {
          //         const tieneContenido = Object.values(fullBuscador).some(
          //           (valor) =>
          //             valor !== "" && valor !== undefined && valor !== null
          //         );

          //         if (!tieneContenido) {
          //           mostrarAlerta(
          //             "Debe ingresar al menos un parámetro de busqueda",
          //             "error"
          //           );
          //           return false;
          //         }

          //         return true;
          //       };

          //       if (!validarFullBuscador(fullBuscador)) {
          //         return;
          //       }
          //       setcargandoDialogOpciones(true);
          //       const body = {
          //         tipo: "todos",
          //         rucempresa: usuario.rucempresa,
          //         lista: [],
          //         search_avanzado: fullBuscador,
          //       };
          //       console.log(`/reportes/excel/abastecimiento`, { body });
          //       const res = await clienteAxios.post(
          //         `/reportes/excel/abastecimiento`,
          //         body,
          //         { responseType: "blob" }
          //       );
          //       const excelBlob = new Blob([res.data], {
          //         type:
          //           "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          //       });
          //       saveAs(excelBlob, `${"Abastecimiento"}.xlsx`);
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     } catch (error) {
          //       console.log({ error });

          //       mostrarAlerta("Hubo un error", "error");
          //       setopen(false);
          //       setcargandoDialogOpciones(false);
          //     }
          //   },
          //   Icon: BackupTable,
          //   color: "success",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
        ]}
        titulo={"Acciones"}
      >
        <TextField
          type="month"
          value={mes}
          label="Mes"
          name="lado"
          onChange={(e) => {
            setmes(e.target.value);
          }}
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
        />
      </DialogOpciones>
      <ToolBarTable
        pagination={pagination}
        rowsPerPage={rowsPerPage}
        rows={rows}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        ocultarPaginacion={false}
        botonesIzquierdos={[
          {
            tooltip: "Actualizar",
            texto: "Actualizar",
            funcion: () => {
              funcionReload(true);
            },
            disabled: false,
            Icon: Refresh,
            color: "primary",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "text",
            size: "medium",
            sx: {},
          },
          {
            tooltip: "PDF - Seleccione: Usuario y Horario",
            texto: "",
            funcion: async () => {
              setcargandoPdfDownload(true);
              console.log(fullBuscador);
              const json = {
                rucempresa: "CADENA",
                lista: [],
                search_avanzado: {
                  fechaHora1:
                    fullBuscador.usuario.length > 1
                      ? fullBuscador.fechaHora1
                      : fullBuscador.horarios.split(" - ")[0],
                  fechaHora2:
                    fullBuscador.usuario.length > 1
                      ? fullBuscador.fechaHora2
                      : fullBuscador.horarios.split(" - ")[1],
                  usuario: fullBuscador.usuario,
                },
              };
              if (
                (json.search_avanzado.fechaHora1 === "" &&
                  json.search_avanzado.fechaHora2 === "") ||
                fullBuscador.usuario.length === 0
              ) {
                return mostrarAlerta(
                  "Por favor, seleccione un horario y un usuario, o varios usuarios junto con un rango de fechas.",
                  "error"
                );
              }
              console.log(fullBuscador);

              console.log({ json });

              try {
                const res = await clienteAxios.post(
                  `/reportes/cierre_caja_gasolinera`,
                  {
                    ...json,
                  },
                  { responseType: "blob" }
                );
                const pdfBlob = new Blob([res.data], {
                  type: "application/pdf",
                });
                saveAs(pdfBlob, `Reporte ${fullBuscador.usuario}.pdf`);
                setopen(false);
                setcargandoPdfDownload(false);
              } catch (error) {
                console.log({ error });
                mostrarAlerta("Error al generar el reporte", "error");
                setcargandoPdfDownload(false);
              }
            },
            disabled: cargandoPdfDownload,
            Icon: PictureAsPdf,
            color: "error",
            id: 2,
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "medium",
            sx: { margin: "0 0 0 auto" },
          },
        ]}
        botonesDerechos={[
          {
            tooltip: "Exportar",
            texto: "",
            funcion: () => {
              setopenDialogOpciones(true);
            },
            // disabled: arrayExport.length === 0,
            Icon: ListRounded,
            color: "primary",
            id: 1,
            ocultar: false,
            tipo: "icono",
            variante: "text",
            size: "medium",
            sx: { margin: 0, padding: 0 },
          },
        ]}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" id="tabla" size="small">
          <TableHead>
            <TablaCabecera
              rows={rows}
              setarrayExport={setarrayExport}
              campoExport={campoExport}
              columns={columns}
              habilitarOrdenar={true}
              //nuevos
              input={input}
              orden={orden}
              funcionOrdenar={funcionOrdenar}
              ocultarPrimeraColumna={true}
            />
          </TableHead>
          <TableBody component={"div"}>
            {open ? <RowNuevo setopen={setopen} socket={socket} /> : null}
            {cargando ? (
              <TableCell
                size="small"
                align="center"
                colSpan={columns.length + 2}
              >
                <Cargando titulo="Cargando..." />
              </TableCell>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <Row
                      key={row[campoExport]}
                      arrayExport={arrayExport}
                      setarrayExport={setarrayExport}
                      row={row}
                      index={index}
                      campoExport={campoExport}
                      socket={socket}
                      seteditarFactura={seteditarFactura}
                      changeObjetoActivoStateFactura={
                        changeObjetoActivoStateFactura
                      }
                      setopenFactura={setopenFactura}
                      ObjectoActivoFactura={ObjectoActivoFactura}
                    />
                  );
                })
            )}
          </TableBody>
          <TableFooter>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <>
              <TableCell
                size="small"
                align="center"
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography
                  variant="body2"
                  color="secondary"
                  style={{
                    fontWeight: "bold",
                    padding: ".0",
                    margin: 0,
                    borderBottom: "1px solid",
                  }}
                  component={"span"}
                >
                  $
                  {rows.length === 0
                    ? null
                    : rows
                        .map((row) => {
                          const existe = arrayExport.some((itemE) => {
                            return itemE === row[campoExport];
                          });

                          if (existe) {
                            return Number(row.valorTotal);
                          }
                          return 0;
                        })
                        .reduce(reducer)
                        .toFixed(2)}
                </Typography>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{ fontWeight: "bold", padding: ".0", margin: 0 }}
                  component={"span"}
                >
                  $
                  {rows.length === 0
                    ? null
                    : rows
                        .map((row) => {
                          return Number(row.valorTotal);
                        })
                        .reduce(reducer)
                        .toFixed(2)}
                </Typography>
              </TableCell>
              <TableCell size="small" align="center">
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    variant="body2"
                    color="secondary"
                    style={{
                      fontWeight: "bold",
                      padding: ".0",
                      margin: 0,
                      borderBottom: "1px solid",
                    }}
                    component={"span"}
                  >
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            const existe = arrayExport.some(
                              (itemE) => itemE === row[campoExport]
                            );

                            if (existe) {
                              return Number(row.volTotal);
                            }
                            return 0;
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{ fontWeight: "bold", padding: ".0", margin: 0 }}
                    component={"span"}
                  >
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            return Number(row.volTotal);
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                </Box>
              </TableCell>
            </>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
          </TableFooter>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default memo(withRouter(Tabla));
